import { IAgent, IInteractionsCount } from "@edgetier/watchtower-types";

/**
 * Lookup counts by agent ID for speed.
 * @param interactionsCounts
 */
const lookupInteractionsCounts = (interactionsCounts: IInteractionsCount<string>[]) => {
    return interactionsCounts.reduce<{ [agentId: string]: number }>(
        (data, { count, group }) => ({ ...data, [group]: count }),
        {}
    );
};

/**
 * Given an array of available agents and counts of their current interactions, combine them into one array.
 * @param agents             Array of available agents.
 * @param interactionsCounts Counts of agents interactions being handled.
 * @returns                  Array of agents and interactions being handled.
 */
export const combineData = (
    agents?: IAgent[],
    interactionsCounts?: IInteractionsCount<string>[],
    stateChangeInteractionsCounts?: IInteractionsCount<string>[]
) => {
    if (!Array.isArray(agents) || !Array.isArray(interactionsCounts) || !Array.isArray(stateChangeInteractionsCounts)) {
        return [];
    }

    const keyedInteractionsCounts = lookupInteractionsCounts(interactionsCounts);
    const keyedStateChangeInteractionsCounts = lookupInteractionsCounts(stateChangeInteractionsCounts);

    return agents.map(({ agentId, agentState, agentStateUpdateDateTime, name, agentStateId, lastLoginDateTime }) => ({
        agentId,
        agentState,
        agentStateId,
        lastLoginDateTime,
        agentStateUpdateDateTime,
        handling: keyedInteractionsCounts[agentId] ?? 0,
        stateChangeInteractions: keyedStateChangeInteractionsCounts[agentId] ?? 0,
        name,
    }));
};
